var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitSearchIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#DEECFE",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6665 20V25.3333C34.6665 25.687 34.807 26.0261 35.057 26.2761C35.3071 26.5262 35.6462 26.6667 35.9998 26.6667H41.3332M34.6665 20H25.3332C24.6259 20 23.9476 20.281 23.4476 20.781C22.9475 21.2811 22.6665 21.9594 22.6665 22.6667V41.3333C22.6665 42.0406 22.9475 42.7189 23.4476 43.219C23.9476 43.719 24.6259 44 25.3332 44H31.9998M34.6665 20L41.3332 26.6667M41.3332 26.6667V32.6667M40.6665 42L43.9998 45.3333M34.6665 39.3333C34.6665 40.2174 35.0177 41.0652 35.6428 41.6904C36.2679 42.3155 37.1158 42.6667 37.9998 42.6667C38.8839 42.6667 39.7317 42.3155 40.3569 41.6904C40.982 41.0652 41.3332 40.2174 41.3332 39.3333C41.3332 38.4493 40.982 37.6014 40.3569 36.9763C39.7317 36.3512 38.8839 36 37.9998 36C37.1158 36 36.2679 36.3512 35.6428 36.9763C35.0177 37.6014 34.6665 38.4493 34.6665 39.3333Z",
    stroke: "#0857C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitSearchIcn);
export default __webpack_public_path__ + "static/media/benefit-search-icn.67ab24a02f824c847416c748e2948c2c.svg";
export { ForwardRef as ReactComponent };